import POSCreate from "../components/pages/pos/POSCreate";
import POSPage from "../components/pages/pos/POSPage";
import POSSetupPage from "../components/pages/pos/POSSetupPage";
import POSConnectFields from "../components/pages/pos/POSConnectFields";
import POSAuth from "../components/pages/pos/POSAuth";

const routes = [
    {
        path: "/pos",
        element: <POSPage />
    },
    {
        path: "/pos/create",
        element: <POSCreate />
    },
    {
        path: "/pos/edit/:posID",
        element: <POSCreate />
    },
    {
        path: "/pos/setup",
        element: <POSSetupPage />
    },
    {
        path: "/pos/connectfields",
        element: <POSConnectFields />
    },
    {
        path: "/pos/auth",
        element: <POSAuth />
    }
];

export default routes;
